import React from 'react'
import { LinkOutlined } from '@ant-design/icons'
import { Card, Typography, Row, Col, Input } from 'antd'

import moment from 'moment-timezone'
import PropTypes from 'prop-types'
import { RecommendationsSelector, ImageUploaderToS3 } from '~components'
import { MSG_BASE_URL } from '~constants'
import { Checkbox, DatePicker, MultiSelectDropdown, TimePicker } from '~stories'
import { getShortTimeZone } from '~utils'

import styles from './EventInfo.module.css'

const { Title } = Typography

const FORMATTER = {
  DATE: 'MM/DD/YYYY',
  TIME: 'HH:mm:ss'
}
const DEFAULT_EVENT_PULL_DOWN_HOURS = 3
const { REACT_APP_STAGE } = process.env

const EventInfo = ({ event, handleArtistTMUrl, handleEnableStickyCta, allSubCategories, selectedSubCategories, handleEventEndDateUpdate, handleTourUpdate, selectedRoxGroupFlags, selectedRoxFlags, handleSpanMultipleDaysUpdate, handleEventPullDownTimeUpdate, handleStartTimeUpdate, handleDoorOpenTimeUpdate, handleEventDetailIconUpdate, selectedSphereFlags, selectedFlags, handleFlagsUpdate, handleSphereFlagsUpdate, handleRoxFlagsUpdate, handleRoxGroupFlagsUpdate, handleSubCategoriesUpdate, handleCategoriesUpdate, selectedCategories, handleNameUpdate, handleSlug, handleSubtitleUpdate, handleEventStatus, handlePostponed, allArtists, onHeadlinerClick, promotedArtists, setAllArtists, setPromotedArtists }) => {
  const isRoxEvent = event?.artists.map(artist => artist?.id).includes('K8vZ9171K10')

  const [series] = event?.series || []
  const { id: seriesId } = series || {}
  const [selectedVenue] = event?.venue || []
  const selectedState = selectedVenue ? `${selectedVenue?.city} / ${selectedVenue?.state}` : ''
  const isSphereEvent = selectedVenue?.id === 'KovZ917Atbr'

  const eventStartDate = moment.utc(event?.startDate)
  console.log(event, selectedSphereFlags)
  const eventStartTime = event?.startTime !== 'TBA' && moment(event?.startTime, FORMATTER.TIME)
  const eventDoorOpenTime = event?.doorOpenTime !== 'TBA' && moment(event?.doorOpenTime, FORMATTER.TIME)
  const eventPullDownTime = event?.pullDownFromSystem ? moment.tz(event?.pullDownFromSystem, event?.timezone) : moment.utc(event?.dateTime).tz(event?.timezone).add(DEFAULT_EVENT_PULL_DOWN_HOURS, 'hours')
  const eventEndDate = event?.endDate ? moment.utc(event?.endDate) : eventStartDate

  const slugUrl = (REACT_APP_STAGE === 'production') ? `${MSG_BASE_URL.PROD}${event?.slug}` : `${MSG_BASE_URL.NON_PROD}${event?.slug}`
  return (
    <div className={styles['event-information-event']}>
      <Title className={styles['title-text']} level={2}>Event Information</Title>
      <Card className={styles['card-container']}>
        <Row align={'middle'} className={styles['title-wrapper']}>
          <Col><Title level={3}>Slug* </Title></Col>
          <Col>&nbsp;&nbsp;<a href={slugUrl} rel='noreferrer' target='_blank'><LinkOutlined /></a></Col>
        </Row>
        <Row>
          <Col span={24}>
            <Input
              {
                ...!isRoxEvent && {
                  addonBefore: '/events-tickets'
                }
              }
              onChange={handleSlug}
              required
              style={{ width: '100%' }}
              value={`${event?.slug}` || ''}
            />
          </Col>
        </Row>
      </Card>
      <Card className={styles['card-container']}>
        <Row align={'middle'} className={styles['title-wrapper']}>
          <Col><Title level={3}>Event Name* </Title></Col>
          <Col><Title level={4}>&nbsp;&nbsp;(70 characters max; name of event)</Title></Col>
        </Row>
        <Row>
          <Col span={24}>
            <Input
              count={{ show: true, max: 70 }}
              onChange={handleNameUpdate}
              required
              style={{ width: '100%' }}
              value={event?.name || ''}
            />
          </Col>
        </Row>
      </Card>
      <Card className={styles['card-container']}>
        <Row align={'middle'} className={styles['title-wrapper']}>
          <Col><Title level={3}>Event Tour Name</Title></Col>
          <Col><Title level={4}>&nbsp;&nbsp;(128 characters max; input tour name, etc.)</Title></Col>
        </Row>
        <Row>
          <Col span={24}>
            <Input
              maxLength={128}
              onChange={handleSubtitleUpdate}
              style={{ width: '100%' }}
              value={event?.subTitle || ''}
            />
          </Col>
        </Row>
      </Card>
      <Card className={styles['card-container']}>
        <Row align={'middle'} className={styles['title-wrapper']}>
          <Col><Title level={3}>Special Guest</Title></Col>
          <Col><Title level={4}>&nbsp;&nbsp;(128 characters max; input tour name, etc.)</Title></Col>
        </Row>
        <Row>
          <Col span={24}>
            <Input
              maxLength={128}
              onChange={handleTourUpdate}
              style={{ width: '100%' }}
              value={event?.tourName || ''}
            />
          </Col>
        </Row>
      </Card>
      <Card className={styles['card-container']}>
        <Row>
          <Col span={24}>
            <label style={{ alignItems: 'center', cursor: 'pointer', display: 'inline-flex' }}>
              <Checkbox
                checked={event?.postponed || false}
                onChange={handlePostponed}
              />
              <span style={{ marginLeft: 8 }}>Postponed</span>
            </label>
          </Col>
        </Row>
      </Card>
      <Card className={styles['card-container']}>
        <Row align={'middle'} className={styles['title-wrapper']} justify={'space-between'}>
          <Col flex='auto' span={18}><Title level={3}>Sticky CTA Url</Title></Col>
          <Col span={6}><Title level={3}>Show Sticky CTA</Title></Col>
        </Row>
        <Row align={'middle'} gutter={16}>
          <Col flex='auto' span={18}>
            <Input
              onChange={handleArtistTMUrl}
              style={{ width: '100%' }}
              value={event?.artistTmUrl || ''}
            />
          </Col>
          <Col flex='auto' span={6}>
            <Checkbox
              checked={event?.enableStickyCta || false}
              onChange={handleEnableStickyCta}
            />
          </Col>
        </Row>
      </Card>
      {/* {event?.status === 'presale' && <Card className={styles['card-container']}>
        <Row align={'middle'} className={styles['title-wrapper']}>
          <Col><Title level={3}>Special Guest</Title></Col>
          <Col><Title level={4}>&nbsp;&nbsp;(128 characters max; input tour name, etc.)</Title></Col>
        </Row>
        <Row>
          <Col span={24}>
            <Input
              maxLength={128}
              onChange={handleSpecialGuestUpdate}
              style={{ width: '100%' }}
              value={event?.specialGuest || ''}
            />
          </Col>
        </Row>
      </Card>} */}
      <Card className={styles['card-container']}>
        <Row align={'middle'} className={styles['title-wrapper']}>
          <Col><Title level={3}>Event Image* </Title></Col>
          <Col><Title level={4}>&nbsp;&nbsp;(Upload PNG or JPG; preferred dimensions 1024px x 576px; max file size 1MB)</Title></Col>
        </Row>
        <Row gutter={[10, 10]}>
          <Col align='end' justifyContent='left' span={18} style={{ display: 'flex' }}>
            <ImageUploaderToS3 handleUpload={handleEventDetailIconUpdate} logoUrl={event?.defaultImage?.url} />
          </Col>
        </Row>
      </Card>
      <Card title="Artists">
        {event && <RecommendationsSelector
          allEvents={allArtists}
          onHeadlinerClick={onHeadlinerClick}
          promotedEvents={promotedArtists}
          resourceName='Artists'
          setAllEvents={setAllArtists}
          setPromotedEvents={setPromotedArtists}
          showHeadlinerSelection={true}
        />}
      </Card>
      {/* <Card className={styles['card-container']}>
        <Row align={'middle'} className={styles['title-wrapper']}>
          <Col><Title level={3}>Event Artist/Team/Performer* </Title></Col>
          <Col><Title level={4]}>(Select one item or more from dropdown)</Title></Col>
        </Row>
        <Row>
          <Col span={24}>
            {
              event?.allArtists && <RecommendationsSelector
                allEvents={event?.allArtists || []}
                onHeadlinerClick={onHeadlinerClick}
                promotedEvents={promotedEvents}
                resourceName='Artists'
                setAllEvents={setAllEvents}
                setPromotedEvents={setPromotedEvents}
                showHeadlinerSelection={true}
              />
            }
          </Col>
        </Row>
      </Card> */}
      <Row>
        <Col span={12}>
          <Card className={styles['card-container']}>
            <Row align={'middle'} className={styles['title-wrapper']}>
              <Col span={12}>
                <Title level={3}>Event Venue*</Title>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Input
                  count={{ show: true, max: 70 }}
                  disabled
                  style={{ width: '100%' }}
                  value={selectedVenue?.name || ''}
                />
              </Col>
            </Row>
          </Card>
        </Col>
        <Col span={12}>
          <Card className={styles['card-container']}>
            <Row align={'middle'} className={styles['title-wrapper']}>
              <Col span={12}>
                <Title level={3}>Event City/State*</Title>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Input
                  count={{ show: true, max: 70 }}
                  disabled
                  style={{ width: '100%' }}
                  value={selectedState}
                />
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col span={8}>
          <Card className={styles['card-container']}>
            <Row align={'middle'} className={styles['title-wrapper']}>
              <Col span={12}>
                <Title level={3}>Event Date*</Title>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <DatePicker
                  className={styles['component-width-90']}
                  disabled={true}
                  value={eventStartDate}
                />
              </Col>
            </Row>
          </Card>
        </Col>
        <Col span={8}>
          <Card className={styles['card-container']}>
            <Row align={'middle'} className={styles['title-wrapper']}>
              <Col span={12}>
                <Title level={3}>Event Start Time*</Title>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <TimePicker
                  disabled={!event?.spanMultipleDays}
                  format='h:mm A'
                  onChange={handleStartTimeUpdate}
                  value={eventStartTime}
                />{' '}
                {getShortTimeZone(event?.timezone)}
              </Col>
            </Row>
          </Card>
        </Col>
        <Col span={8}>
          <Card className={styles['card-container']}>
            <Row align={'middle'} className={styles['title-wrapper']}>
              <Col span={12}>
                <Title level={3}>Event Door Time*</Title>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <TimePicker
                  format='h:mm A'
                  onChange={handleDoorOpenTimeUpdate}
                  value={eventDoorOpenTime}
                />{' '}
                {getShortTimeZone(event?.timezone)}
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
      <Card className={styles['card-container']}>
        <Row align={'middle'} className={styles['title-wrapper']}>
          <Col><Title level={3}>Event Status*</Title></Col>
          <Col><Title level={4}>&nbsp;&nbsp;(Select one item from dropdown)</Title></Col>
        </Row>
        <Row>
          <Col span={24}>
            <MultiSelectDropdown
              customStyle={{ width: '100%' }}
              displayField="label"
              dropdownOptions={event?.eventStatusList || []}
              handleChange={handleEventStatus}
              selectedItems={[event?.status]}
              valueField="value"
            />
          </Col>
        </Row>
      </Card>
      <Card className={styles['card-container']}>
        <Row align={'middle'} className={styles['title-wrapper']}>
          <Col><Title level={3}>Series</Title></Col>
        </Row>
        <Row align={'middle'} className={styles['title-wrapper']}>
          <Col><a href={`/series/${seriesId}/edit`} rel='noreferrer' target='_blank'>{seriesId}</a></Col>
        </Row>
      </Card>
      <Card className={styles['card-container']}>
        <Row align={'middle'} className={styles['title-wrapper']}>
          <Col><Title level={3}>Filter Categories*</Title></Col>
          <Col><Title level={4}>&nbsp;&nbsp;(Select one or more items from dropdown)</Title></Col>
        </Row>
        <Row>
          <Col span={24}>
            <MultiSelectDropdown
              allowClear={true}
              displayField="name"
              dropdownOptions={event?.allCategories || []}
              handleChange={handleCategoriesUpdate}
              mode='multiple'
              selectedItems={selectedCategories}
              valueField="name"
            />
          </Col>
        </Row>
      </Card>
      <Card className={styles['card-container']}>
        <Row align={'middle'} className={styles['title-wrapper']}>
          <Col><Title level={3}>Filter Subcategories</Title></Col>
          <Col><Title level={4}>&nbsp;&nbsp;(Select one or more items from dropdown)</Title></Col>
        </Row>
        <Row>
          <Col span={24}>
            <MultiSelectDropdown
              allowClear={true}
              displayField="name"
              dropdownOptions={allSubCategories || []}
              handleChange={handleSubCategoriesUpdate}
              mode='multiple'
              selectedItems={selectedSubCategories}
              valueField="name"
            />
          </Col>
        </Row>
      </Card>
      <Card className={styles['card-container']}>
        <Row align={'middle'} className={styles['title-wrapper']}>
          <Col><Title level={3}>MSG Event Flags</Title></Col>
          <Col><Title level={4}>&nbsp;&nbsp;(Select one item from the dropdown)</Title></Col>
        </Row>
        <Row>
          <Col span={24}>
            <MultiSelectDropdown
              allowClear={true}
              displayField="title"
              dropdownOptions={event?.msgFlagsList || []}
              handleChange={handleFlagsUpdate}
              selectedItems={selectedFlags}
              valueField="title"
            />
          </Col>
        </Row>
      </Card>
      { isSphereEvent && <Card className={styles['card-container']}>
        <Row align={'middle'} className={styles['title-wrapper']}>
          <Col><Title level={3}>Sphere Event Flags</Title></Col>
          <Col><Title level={4}>&nbsp;&nbsp;(Select one item from the dropdown)</Title></Col>
        </Row>
        <Row>
          <Col span={24}>
            <MultiSelectDropdown
              allowClear={true}
              displayField="title"
              dropdownOptions={event?.sphereFlagsList || []}
              handleChange={handleSphereFlagsUpdate}
              selectedItems={selectedSphereFlags}
              valueField="title"
            />
          </Col>
        </Row>
      </Card> }
      {
        isRoxEvent && <>
          <Card className={styles['card-container']}>
            <Row align={'middle'} className={styles['title-wrapper']}>
              <Col><Title level={3}>Rox Event Flags</Title></Col>
              <Col><Title level={4}>&nbsp;&nbsp;(Select one item from the dropdown)</Title></Col>
            </Row>
            <Row>
              <Col span={24}>
                <MultiSelectDropdown
                  allowClear={true}
                  customStyle={{ width: 450 }}
                  displayField="title"
                  dropdownOptions={event?.roxFlagsList || []}
                  handleChange={handleRoxFlagsUpdate}
                  selectedItems={selectedRoxFlags}
                  valueField="title"
                />
              </Col>
            </Row>
          </Card>
          <Card className={styles['card-container']}>
            <Row align={'middle'} className={styles['title-wrapper']}>
              <Col><Title level={3}>Rox Groups Flags</Title></Col>
              <Col><Title level={4}>&nbsp;&nbsp;(Select one item from the dropdown)</Title></Col>
            </Row>
            <Row>
              <Col span={24}>
                <MultiSelectDropdown
                  allowClear={true}
                  customStyle={{ width: 450 }}
                  displayField="title"
                  dropdownOptions={event?.roxGroupsFlagsList || []}
                  handleChange={handleRoxGroupFlagsUpdate}
                  selectedItems={selectedRoxGroupFlags}
                  valueField="title"
                />
              </Col>
            </Row>
          </Card>
        </>
      }
      <Row>
        <Col span={8}>
          <Card className={styles['card-container']}>
            <Row align={'middle'} className={styles['title-wrapper']}>
              <Col span={12}>
                <Title level={3}>Pull Down Time*</Title>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <DatePicker
                  className={styles.pullDownTimePickerWidth}
                  format={'MM/DD/YYYY h:mm A'}
                  onChange={handleEventPullDownTimeUpdate}
                  showTime={true}
                  value={eventPullDownTime}
                />
              </Col>
            </Row>
          </Card>
        </Col>
        <Col span={8}>
          <Card className={styles['card-container']}>
            <Row align={'middle'} className={styles['title-wrapper']}>
              <Col span={24}>
                <Title level={3}>Span Multiple Days:</Title>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Checkbox
                  checked={event?.spanMultipleDays}
                  onChange={handleSpanMultipleDaysUpdate}
                />
              </Col>
            </Row>
          </Card>
        </Col>
        { event?.spanMultipleDays && <Col span={8}>
          <Card className={styles['card-container']}>
            <Row align={'middle'} className={styles['title-wrapper']}>
              <Col span={12}>
                <Title level={3}>Event End Date:</Title>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <DatePicker
                  className={styles['component-width-90']}
                  format={FORMATTER.DATE}
                  onChange={handleEventEndDateUpdate}
                  value={eventEndDate}
                />
              </Col>
            </Row>
          </Card>
        </Col>}
      </Row>
    </div>
  )
}

EventInfo.propTypes = {
  allArtists: PropTypes.array,
  allSubCategories: PropTypes.array,
  event: PropTypes.object,
  handleArtistTMUrl: PropTypes.func.isRequired,
  handleCategoriesUpdate: PropTypes.func.isRequired,
  handleDoorOpenTimeUpdate: PropTypes.func.isRequired,
  handleEnablePresale: PropTypes.func.isRequired,
  handleEnableStickyCta: PropTypes.func.isRequired,
  handleEventDetailIconUpdate: PropTypes.func.isRequired,
  handleEventEndDateUpdate: PropTypes.func.isRequired,
  handleEventPullDownTimeUpdate: PropTypes.func.isRequired,
  handleEventStatus: PropTypes.func.isRequired,
  handleEventTypeUpdate: PropTypes.func.isRequired,
  handleFlagsUpdate: PropTypes.func.isRequired,
  handleNameUpdate: PropTypes.func.isRequired,
  handlePostponed: PropTypes.func.isRequired,
  handleRoxFlagsUpdate: PropTypes.func.isRequired,
  handleRoxGroupFlagsUpdate: PropTypes.func.isRequired,
  handleSlug: PropTypes.func.isRequired,
  handleSpanMultipleDaysUpdate: PropTypes.func.isRequired,
  handleSpecialGuestUpdate: PropTypes.func,
  handleSphereFlagsUpdate: PropTypes.func.isRequired,
  handleStartTimeUpdate: PropTypes.func.isRequired,
  handleSubCategoriesUpdate: PropTypes.func.isRequired,
  handleSubtitleUpdate: PropTypes.func.isRequired,
  handleTourUpdate: PropTypes.func,
  onHeadlinerClick: PropTypes.func.isRequired,
  promotedArtists: PropTypes.array,
  promotedEvents: PropTypes.array,
  resourceName: PropTypes.string,
  selectedCategories: PropTypes.array,
  selectedFlags: PropTypes.array,
  selectedRoxFlags: PropTypes.array,
  selectedRoxGroupFlags: PropTypes.array,
  selectedSphereFlags: PropTypes.array,
  selectedSubCategories: PropTypes.array,
  setAllArtists: PropTypes.func.isRequired,
  setPromotedArtists: PropTypes.func.isRequired,
  showHeadlinerSelection: PropTypes.bool
}

export default EventInfo
